import React from 'react'
import {observer} from 'mobx-react'
import Overlay from './overlay'
import Top from './Top'
import Main from './Main'
import Login from 'pages/Login'
import Sidebar from './Sidebar'
import store from 'store'

export default observer(() => {
  let {user, state} = store
  return (
    <div class="window">
      {state === 'pending'
        ? <div class="admin-auth-loading" role="status">正在验证后台会话…</div>
        : null
      }
      {do{
        if (state !== 'pending' && user) {
          <Top />
        }
      }}
      {do{
        if (state === 'pending') {
          null
        } else if (!user) {
          <Overlay show={true}>
            <Login />
          </Overlay>
        } else if (user.isAdmin) {
          <div id="window">
            <Sidebar />
            <Main />
          </div>
        } else if (user.requestAdmin) {
          <div class="admin-notice">
            管理员审核中，请等待超级管理员通过
          </div>
        }
      }}
    </div>
  )
})
